import type { FormConfig } from '../types';
import coverSheet from '../pages/tableau/coverSheet';
import spendApproval from '../pages/tableau/spendApproval';

const formConfig: FormConfig = {
  live: true,
  id: 'tableau',
  formName: 'Tableau Placeholder Form',
  title: 'Tableau Placeholder Form',
  subTitle: 'Summary page',
  showSections: true,
  requiredFlag: true,
  approvalAllowUnsubmit: false,
  sections: [
    {
      title: 'Request a Tableau license',
      slug: 'main-section',
      subsections: [
        {
          title: 'Your details',
          slug: 'cover-sheet',
          pages: coverSheet,
        },
        {
          title: 'Spend approval (if applicable)',
          slug: 'spend-approval',
          dependsOn: 'cover-sheet',
          notRequiredWhen: [
            {
              field: 'paid-for-tableau-licence-last-financial-year',
              condition: 'equals',
              value: 'No',
            },
          ],
          pages: spendApproval,
        },
      ],
    },
  ],
};

export default formConfig;
